// extracted by mini-css-extract-plugin
module.exports = {"lds-ellipsis":"style_lds-ellipsis__3Mws9","lds-ellipsis1":"style_lds-ellipsis1__2hQDs","lds-ellipsis2":"style_lds-ellipsis2__1-eee","lds-ellipsis3":"style_lds-ellipsis3__11gKq"};